var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2508"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6279 23.1863C30.4868 23.1863 30.3514 23.1302 30.2516 23.0304C30.1518 22.9306 30.0957 22.7952 30.0957 22.6541V12.4603C30.0957 12.3192 30.1518 12.1838 30.2516 12.084C30.3514 11.9842 30.4868 11.9281 30.6279 11.9281C30.7691 11.9281 30.9044 11.9842 31.0042 12.084C31.104 12.1838 31.1601 12.3192 31.1601 12.4603V22.6541C31.1601 22.7952 31.104 22.9306 31.0042 23.0304C30.9044 23.1302 30.7691 23.1863 30.6279 23.1863Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.1598 2.59174C31.1598 1.4172 30.2042 0.461548 29.0294 0.461548H14.2689C13.0944 0.461548 12.1387 1.4172 12.1387 2.59174V5.32216H2.87265C1.7497 5.32216 0.835938 6.23593 0.835938 7.35888V29.5017C0.835938 30.6246 1.7497 31.5384 2.87265 31.5384H23.3413C23.603 31.5384 23.8152 31.3262 23.8152 31.0645V26.9214H29.0294C30.2042 26.9214 31.1598 25.9658 31.1598 24.791V2.59174ZM2.87265 6.26995H12.1387V8.44781H2.87265C2.27219 8.44781 1.78372 7.95934 1.78372 7.35887C1.78372 6.75841 2.27219 6.26995 2.87265 6.26995ZM22.8674 22.9445H15.2537C13.6544 22.9445 12.353 21.6432 12.353 20.0438C12.353 18.4442 13.6544 17.1428 15.2537 17.1428H22.8674V22.9445ZM22.8674 16.195H15.2537C13.1316 16.195 11.4052 17.9217 11.4052 20.0438C11.4052 22.1659 13.1316 23.8923 15.2537 23.8923H22.8674V30.5906H2.87265C2.27219 30.5906 1.78372 30.1021 1.78372 29.5017V9.0795C2.09887 9.27966 2.47257 9.39559 2.87265 9.39559H22.8674V16.195ZM25.4421 25.9737H23.8152V8.9217C23.8152 8.65999 23.603 8.44781 23.3413 8.44781H13.0865V2.59174C13.0865 1.93968 13.6169 1.40933 14.2689 1.40933H25.4421V25.9737ZM30.2121 24.791C30.2121 25.4431 29.6815 25.9737 29.0294 25.9737H26.3899V1.40933H29.0294C29.6815 1.40933 30.2121 1.93968 30.2121 2.59174V24.791Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/Payment.2c50af8f.svg";
export { ForwardRef as ReactComponent };